module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper_main"
  }, [_c('div', {
    staticClass: "navdiv"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "min-height": "56px"
    }
  }, [_c('li', {
    staticClass: "step_li"
  }, [_c('div', {
    staticClass: "num_container",
    class: {
      'active': _vm.bgcolor == 1
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "title_container",
    class: {
      'active2': _vm.bgcolor == 1
    }
  }, [_vm._v("Abstract content")])]), _vm._v(" "), _c('li', {
    staticClass: "step_li"
  }, [_c('div', {
    staticClass: "num_container",
    class: {
      'active': _vm.bgcolor == 2
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "title_container",
    class: {
      'active2': _vm.bgcolor == 2
    }
  }, [_vm._v("Authers infomation")])]), _vm._v(" "), _c('li', {
    staticClass: "step_li"
  }, [_c('div', {
    staticClass: "num_container",
    class: {
      'active': _vm.bgcolor == 3
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "title_container",
    class: {
      'active2': _vm.bgcolor == 3
    }
  }, [_vm._v("Abstract preview")])]), _vm._v(" "), _c('li', {
    staticClass: "step_li"
  }, [_c('div', {
    staticClass: "num_container",
    class: {
      'active': _vm.bgcolor == 4
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "title_container",
    class: {
      'active2': _vm.bgcolor == 4
    }
  }, [_vm._v("Abstract submitted successfully")])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c7606b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/paper_index.vue
// module id = 792
// module chunks = 10